export default {
  pt: {
    pageTitle: "Autenticação",
    mainTitle: "Autenticação de segurança",
    description: "Insira agora o código que enviamos por SMS para o telefone {phone}.",
    codeLabel: "Código 6 dígitos",
    resendButton: "Reenviar código",
  },

  en: {
    pageTitle: "Authentication",
    mainTitle: "Security authentication",
    description: "Now enter the code we sent by SMS to the phone {phone}.",
    codeLabel: "6-digit code",
    resendButton: "Resend code",
  },
}; 